import React, { useEffect, useState } from "react";
import "./FilterComponent.scss"
import redo from "../../assets/redo.svg"
import close from "../../assets/close.svg"
import gbp from "../../assets/filters/gbp.svg"
import diet from "../../assets/filters/diet.svg"
import sortIc from "../../assets/filters/sort.svg"
import veg from "../../assets/filters/vegetarian.svg"
import vegan from "../../assets/filters/vegan.svg"
import gluten from "../../assets/filters/gluten.svg"
import halal from "../../assets/filters/halal.svg"
import spicy from "../../assets/filters/spicy.svg"
import organic from "../../assets/filters/organic.svg"


import tick from "../../assets/filters/tick.svg"
import DoubleRangeSlider from "../DoubleRangeSlider/DoubleRangeSlider";






const FilterComponent = ({ filters, setFilters, sort, setSort, rangeValue, sortList, setSelected, setPriceRange, priceRange }) => {
    const [range, setRange] = useState({ min: (priceRange.min), max: (priceRange.max) });
    const dietList = [
        {
            name: "Vegetarian",
            icon: veg
        },
        // {
        //     name: "Vegan",
        //     icon: vegan
        // }, 
        {
            name: "Gluten-Free",
            icon: gluten
        }, {
            name: "Halal",
            icon: halal
        }, {
            name: "Spicy",
            icon: spicy
        },
        // {
        //     name: "Organic",
        //     icon: organic
        // },
    ]

    const rangeList = [
        {
            Min: 0,
            Max: 15
        },
        {
            Min: 15,
            Max: 30
        }, {
            Min: 30,
            Max: 50
        },
    ]
    useEffect(() => {
        if (range) {
            if (range.min !== rangeValue.Min || range.max !== rangeValue.Max) {
                let array = filters
                const index = array.findIndex(item => item["type"] === "PRICE");
                if (index > -1) {
                    array[index] = { name: `£${range.min} - £${range.max}`, type: "PRICE" };
                } else {
                    array.push({ name: `£${range.min} - £${range.max}`, type: "PRICE" });
                }
                setFilters([...array])
            }
        }
    }, [range])
    return (
        <div className="FilterComponent">
            <div className="filter-hder-cont">
                <div className="filter-hdr">
                    Filter & Sort
                </div>
                <div className="rest-hedr"
                    onClick={() => {
                        setSelected(null)
                        setFilters([])
                        setSort(sortList[0])
                        setRange({ min: rangeValue.Min, max: rangeValue.Max })
                        setPriceRange({ min: rangeValue.Min, max: rangeValue.Max })


                    }}>
                    <img alt="" src={redo} className="resy-ico" />
                    Reset All Filters
                </div>
            </div>
            <div className="filtesr-contain">
                <div className="filters-itm-cont">
                    <div className="filters-itm-cont-hdr">
                        <div className="filters-itm-hdr">
                            <img alt="" src={gbp} className="ico" />
                            Price Range</div>
                        <div className="range-text-hdr">£{range.min} - £{range.max}</div>
                    </div>
                    <div className="range-slider-filtr-cont">
                        <DoubleRangeSlider
                            min={rangeValue.Min}
                            max={rangeValue.Max}
                            minValue={range.min}
                            maxValue={range.max}
                            onChange={(newRange) => {
                                setRange(newRange)
                                setPriceRange({ min: newRange.min, max: newRange.max })
                            }}
                            hideInputs
                        />
                        <div className="range-list">
                            {rangeList.map((rangVal, key) => {
                                let includes = rangVal.Min === range.min && rangVal.Max === range.max
                                return (
                                    <div className={`range-list-item ${includes ? "includes" : ""}`} key={key}

                                        onClick={() => {
                                            setRange({ min: rangVal.Min, max: rangVal.Max })
                                            setPriceRange({ min: rangVal.Min, max: rangVal.Max })

                                        }
                                        }>
                                        {rangVal.Min === rangeValue.Min ? `Under £${rangVal.Max}` :
                                            rangVal.Max === rangeValue.Max ? `Over £${rangVal.Min}` :
                                                `£${rangVal.Min} - £${rangVal.Max}`
                                        }

                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="filters-itm-cont">
                    <div className="filters-itm-cont-hdr">
                        <div className="filters-itm-hdr">
                            <img alt="" src={diet} className="ico" />
                            Dietary Preferences</div>


                    </div>
                    <div className="diet-grid">
                        {dietList.map((item) => {
                            let includes = filters.find((val) => val.name === item.name)
                            return (
                                <div className={`diet-item ${includes ? "includes" : ""}`}
                                    onClick={() => {
                                        if (!includes) {
                                            setFilters([...filters, { name: item.name, type: "DIET" }])
                                        } else {
                                            let updated = filters.filter((val) => val.name !== item.name)
                                            setFilters(updated)
                                        }
                                    }}>
                                    <img alt="" src={item.icon} className="ico" />
                                    {item.name}
                                </div>
                            )
                        })}
                    </div>

                </div>
                <div className="filters-itm-cont">
                    <div className="filters-itm-cont-hdr">
                        <div className="filters-itm-hdr">
                            <img alt="" src={sortIc} className="ico" />
                            Sort By</div>

                    </div>
                    <div className="sort-list">
                        {sortList.map((item) => {
                            let includes = sort.value === item.value
                            return (
                                <div className={`diet-item ${includes ? "includes" : ""}`}
                                    onClick={() => {
                                        setSort(item)
                                    }}>
                                    <div className="item-i">

                                        <img alt="" src={item.icon} className="ico" />
                                        {item.label}</div>
                                    {includes && <img alt="" src={tick} className="ico" />}

                                </div>
                            )
                        })}
                    </div>

                </div>
            </div>
            {filters.length > 0 && <div className="selectedFiltes-cont ">
                Active Filters:
                {filters.map((filter) => {
                    return (
                        <div className="flte-itm"
                        >{filter.name}
                            <img alt="" src={close} className="cls-ico"
                                onClick={() => {
                                    if (filter.type === "DIET") {
                                        let updated = filters.filter((val) => val.name !== filter.name)
                                        setFilters(updated)
                                    } else if (filter.type === "PRICE") {
                                        let updated = filters.filter((val) => val.type !== "PRICE")
                                        setFilters(updated)
                                        setRange({ min: rangeValue.Min, max: rangeValue.Max })
                                    } else {
                                        let updated = filters.filter((val) => val.type !== "CATEGORY")
                                        setFilters(updated)
                                        setSelected(null)

                                    }
                                }} /></div>
                    )
                })}
            </div>}
        </div>
    )
}
export default FilterComponent